export default [
  { name: 'Name', prop: 'name', type: 'text' },
  { name: 'Program', prop: 'program_id', type: 'autocomplete', references: 'admin/programs', referenceProp: 'name' },
  { name: 'Start', prop: 'start_at', type: 'date' },
  { name: 'End', prop: 'end_at', type: 'date' },
  { name: 'Reminders start', prop: 'reminders_start', type: 'date' },
  { name: 'Reminders end', prop: 'reminders_end', type: 'date' }
]
